import HonjoNumber from './HonjoNumber.vue'

export { HonjoNumber }
